import React from 'react';
import PageHelmet from '../../components/seo/PageHelmet';
import Layout from '../../components/ui/Layout';
import { Container } from 'react-bootstrap';
import { CONTACT_INFO } from '../../constants/contact';

export default function RefundPolicy() {
  return (
    <Layout>
      <PageHelmet
        title="Refund Policy | Pack My Cart"
        description="Learn about refund eligibility and how to request a refund for your Pack My Cart grocery order."
        path="/refund-policy"
        robots="index, follow"
      />
      <Container className="mt-4">
        <h1>Refund Policy</h1>
        <p>We want you to be satisfied with your purchase. If you are not completely satisfied, please review our refund policy below.</p>
        <h4>Confirmation Fee for Cart Packing</h4>
        <p>
          When you place an order through Pack My Cart, you pay a confirmation fee to reserve your cart and have it packed by the supermarket.
          This confirmation fee is <strong>non-refundable</strong>.
        </p>
        <ul>
          <li>
            <strong>Supermarket cancellation:</strong> If the supermarket cancels your order, the confirmation fee will be refunded to you.
          </li>
          <li>
            <strong>All other cases:</strong> No refund will be issued. This includes if you cancel the order, change your mind, fail to collect your order, or for any other reason not caused by the supermarket cancelling the order.
          </li>
        </ul>
        <h4>Eligibility for Refunds</h4>
        <ul>
          <li>Refund requests must be made within 7 days of purchase.</li>
          <li>Products must be unused and in the same condition as received.</li>
        </ul>
        <h4>How to Request a Refund</h4>
        <ul>
          <li>Contact us at {CONTACT_INFO.email} with your order details and reason for refund.</li>
          <li>We will review your request and respond within 3 business days.</li>
        </ul>
        <h4>Contact Us</h4>
        <p>If you have any questions about our Refund Policy, please contact us at {CONTACT_INFO.email}.</p>
      </Container>
    </Layout>
  );
} 